@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col w-full">
      <div class="flex flex-row items-center w-full">
        @if (field.browserOpts?.inLineWithCaption) {
          <mat-label class="mr-2 mb-4 font-medium">
            {{ field.label | localize }}@if (field.required) {
            <span> *</span>
          }
        </mat-label>
      }
      <div class="flex flex-col w-full">
        @if (!field.compactMode) {
          <div class="flex flex-row justify-end">
            <mat-button-toggle-group [(ngModel)]="selectedLang" ngDefaultControl>
              @for (lang of availableLangs; track lang) {
                <mat-button-toggle [value]="lang.id">
                  <mat-icon class="icon-size-5 mr-2"
                    [svgIcon]="field.control.value[lang.id] ? 'heroicons_solid:star' : 'heroicons_outline:star'">
                  </mat-icon>
                  @if (!field.useFlags) {
                    <span>{{ lang.label }}</span>
                  }
                  @if (field.useFlags) {
                    <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: lang.id }">
                    </ng-container>
                  }
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          </div>
        }
                <mat-form-field class="flex-auto" [ngClass]="{
                        'fuse-mat-textarea': field.view === 'LANGUAGETEXTAREA',
                        'invalid': !field.readonly && field.control.status === 'INVALID' && field.control.touched,
                        '-mt-3': !field.compactMode
                    }">
          @if (!field.browserOpts?.inLineWithCaption) {
            <mat-label>{{ field.label | localize }}</mat-label>
          }
          @switch (field.view) {
            @case ('LANGUAGETEXT') {
                            <input matInput [formControl]="field.control | dTypeFormControl:selectedLang" [ngClass]="{
                                    'text-left': !field.browserOpts || field.browserOpts?.alignment === 'LEFT',
                                    'text-center': field.browserOpts?.alignment === 'CENTER',
                                    'text-right': field.browserOpts?.alignment === 'RIGHT',
                                    'uppercase': field.transform === 'UPPERCASE',
                                    'lowercase': field.transform === 'LOWERCASE'
                                }" [placeholder]="field.placeholder | localize" [readonly]="field.readonly"
                autocomplete="off" />
              }
              @case ('LANGUAGETEXTAREA') {
                            <textarea matInput [formControl]="field.control | dTypeFormControl:selectedLang" [ngClass]="{
                                    'text-left': !field.browserOpts || field.browserOpts?.alignment === 'LEFT',
                                    'text-center': field.browserOpts?.alignment === 'CENTER',
                                    'text-right': field.browserOpts?.alignment === 'RIGHT',
                                    'uppercase': field.transform === 'UPPERCASE',
                                    'lowercase': field.transform === 'LOWERCASE'
                                }" [placeholder]="field.placeholder | localize" [readonly]="field.readonly"
                autocomplete="off"></textarea>
              }
            }
            @if (field.compactMode) {
              <mat-select [(ngModel)]="selectedLang" matPrefix>
                @if (field.useFlags) {
                  <mat-select-trigger>
                    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: selectedLang}">
                    </ng-container>
                  </mat-select-trigger>
                }
                @for (lang of availableLangs; track lang) {
                  <mat-option [value]="lang.id">
                    @if (!field.useFlags) {
                      {{ lang.id }}
                    }
                    @if (field.useFlags) {
                      <span class="flex items-center">
                        <ng-container *ngTemplateOutlet="flagImage; context: { $implicit: lang.id }">
                        </ng-container>
                      </span>
                    }
                  </mat-option>
                }
              </mat-select>
            }
            @if (!field.compactMode) {
              <mat-icon class="icon-size-5" matPrefix svgIcon="mat_outline:translate">
              </mat-icon>
            }
            <mat-hint>
              @if (!field.readonly &&
                field.control.touched &&
                field.control.hasError('required')) {
                <span class="text-warn">{{ 'errorLocaleTextRequired' | transloco }}</span>
              } @else {
                @if (field.hint) {
                  <span>{{ field.hint | localize }}</span>
                }
              }
            </mat-hint>
            @if (!field.readonly && field.control.touched && field.control.errors) {
              <mat-error>
                <ng-container
                  *ngTemplateOutlet="errors; context: { $implicit: field.control | dTypeFormControl:selectedLang }">
                </ng-container>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  }
} @else {
  {{ field.control.value | localize }}
}


<ng-template let-lang #flagImage>
  <span class="relative w-6 shadow rounded-sm overflow-hidden">
    <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
    <img class="w-full" [src]="'assets/images/flags/' + lang + '.svg'" [alt]="'Flag image for ' + lang">
  </span>
</ng-template>

<ng-template #errors let-control>
  @if (control.hasError('minlength')) {
    {{ 'errorMinLengthField' | transloco:{ requiredLength: control.errors.minlength.requiredLength } }}
  }
  @if (control.hasError('maxlength')) {
    {{ 'errorMaxLengthField' | transloco:{ requiredLength: control.errors.maxlength.requiredLength } }}
  }
</ng-template>
